import { request } from '../api/client'
import type { CatalogPage, CatalogParams } from './types'

export const adminI18nClient = {
  list(params: CatalogParams, signal?: AbortSignal): Promise<CatalogPage> {
    const query = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) query.set(key, String(value))
    }
    return request<CatalogPage>(`/coach/admin/translations?${query}`, { signal })
  },
}
